import { createAction } from "@reduxjs/toolkit";

export const increment = createAction("INCREMENT", (val) => {
  return {
    payload: {
      val: val * 4,
    },
  };
});
export const decrement = createAction("DECREMENT", function prepareDecrement(
  quantity
) {
  return {
    payload: {
      quantity: quantity * 2,
    },
  };
});
export const productInfo = createAction("PRODUCT-INFO");
export const vendorDrafSuccess = createAction("VENDOR_DRAFT_SUCCESS");
export const vendorDraftList = createAction("VENDOR_DRAFT_LIST");
export const vendorPendingActionRequests = createAction(
  "VENDOR_PENDING_ACTIONS_REQUESTS"
);
export const vendorRetreievedPendingActions = createAction(
  "RETREIVED_PENDING_ACTIONS_REQUESTS"
);
export const storeCurrentReviewableAction = createAction(
  "STORE_CURRENT_REVIEWABLE_ACTION"
);
export const fetchActionRequestDetails = createAction(
  "FETCH_ACTION_REQUEST_DETAILS"
);
// ACTION REQUEST ACTIONS
export const loadingActionRequests = createAction("LOADING_ACTION_REQUESTS");
export const updateCurrentActionStatus = createAction(
  "UPDATE_CURRENT_ACTION_STATUS"
);
export const vendorApprovedResponse = createAction("VENDOR_APPROVED_RESPONSE");
export const vendorRequestEditsResponse = createAction(
  "VENDOR_REQUEST_EDITS_RESPONSE"
);
